<!-- Normal Breadcrumb Begin -->
<div class="body">
    <div class="normal-breadcrumb set-bg" style="background-image: url('assets/img/banner/vr-banner.jpg')">
        <div class="container">
            <div class="row">
                <div class="col-lg-12 text-center">
                    <div class="normal__breadcrumb__text">
                        <h2>Verify</h2>
                        <p>Verify and Enjoy YoGames.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Normal Breadcrumb End -->
  
    <!-- Signup Section Begin -->
    <div class="signup spad">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <div class="login__form">
              <h3 class="text-center">Verify Account OTP</h3>
        
              
                    <div class="inputfield">
                        <input type="text" maxlength="1" class="input" #input1 (keyup)="onKeyup($event, input1, input2, null,'1')" (keydown)="onBackspace($event, input1, null,'1')" pattern="[0-9]" />
                        <input type="text" maxlength="1" class="input" #input2 (keyup)="onKeyup($event, input2, input3, input1,'2')" (keydown)="onBackspace($event, input2, input1,'2')" pattern="[0-9]" />
                        <input type="text" maxlength="1" class="input" #input3 (keyup)="onKeyup($event, input3, input4, input2,'3')" (keydown)="onBackspace($event, input3, input2,'3')" pattern="[0-9]" />
                        <input type="text" maxlength="1" class="input" #input4 (keyup)="onKeyup($event, input4, null, input3,'4')" (keydown)="onBackspace($event, input4, input3,'4')" pattern="[0-9]" />
                      </div>
<br>
       
                      <div class="centered-container">
                     <button type="submit" class="site-btn " (click)="validateOTP()">Verify</button>
               </div>   
                        <div class="centered-container">
                            <h5>Didnt receive OTP ? <a  (click)="resendOtp()"> Resend </a></h5>
                            </div>
                
               
              
  
              <h5 class="text-center">Already have an account? <a href="/login">Log In!</a></h5>
            
            </div>
          </div>
  
        </div>
      </div>
    </div>
    <!-- Signup Section End -->
  </div>
  